import useNotifications from '@/hooks/fetch-store-and-stitch/use-notifications';
import type { Notification } from '@/models/registry';
import { observer } from 'mobx-react-lite';
import React, { createContext, useContext } from 'react';

interface NotificationsContextType {
  notifications: Notification[];
  numberOfUnreadNotifications: number;
}

const NotificationsContext = createContext<
  NotificationsContextType | undefined
>(undefined);

export const NotificationsProvider: React.FC<{
  children: React.ReactNode;
}> = observer(({ children }) => {
  const { notifications, numberOfUnreadNotifications } = useNotifications();

  return (
    <NotificationsContext.Provider
      value={{
        notifications,
        numberOfUnreadNotifications,
      }}
    >
      {children}
    </NotificationsContext.Provider>
  );
});

export const useNotificationsContext = () => {
  const context = useContext(NotificationsContext);
  if (!context) {
    throw new Error(
      'useNotificationsContext must be used within a NotificationsProvider',
    );
  }
  return context;
};
